import baustein from "baustein";

let tippy;

export default baustein.register("tooltip-tippy", {
    defaultOptions: {
        placement: "bottom",
        interactive: false,
        interactiveBorder: 20,
        arrow: true,
        autoShow: false,
        autoHide: false,
        tippyOnCurrentElement: false,
        flipBehavior: "flip",
        // zIndex same as overlay
        zIndex: 799,
    },

    onInsert() {
        import(/* webpackChunkName: "tippy" */ "tippy.js").then(({ default: tippyLib }) => {
            tippy = tippyLib;

            this.render();

            if (this.options.autoShow) {
                this.timeoutShow = setTimeout(() => {
                    this.el._tippy.show();

                    if (this.options.autoHide) {
                        this.timeoutHide = setTimeout(() => {
                            this.el._tippy.hide();
                        }, this.options.autoHide * 1000);
                    }
                }, this.options.autoShow * 1000);
            }
        });
    },

    render() {
        const contentEl = this.el.querySelector(".tooltip_html_content");
        if (contentEl) {
            const hintBubble = document.createElement("span");
            hintBubble.classList.add("hint-bubble");
            this.el.appendChild(hintBubble);
            this.el.classList.add("tooltip--hint-bubble");
            const options = this.options;
            const tippyOptions = Object.assign({}, options, {
                html: contentEl,
            });
            tippy(hintBubble, tippyOptions);
        } else if (this.options.tippyOnCurrentElement) {
            tippy(this.el, this.options);
        }
    },

    onRemove() {
        if (this.options.tippyOnCurrentElement && this.el._tippy) {
            this.el._tippy.hide(0);
            this.el._tippy.destroy();
        }
        clearTimeout(this.timeoutHide);
    },
});
